import { Button, Box, Text, Bleed, Actions, ButtonLink, Stack } from '@machobear/design-system'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import config from '@/config'
import { DialogEventHandler } from '@/types'

const { APP_PATH, IMAGES_URL } = config

type Props = {
  closeModal: DialogEventHandler
}

const ModalContent = ({ closeModal }: Props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const handleSendMessage = async () => {
    await dispatch.supportRoom.sendMessage({
      message: `Hi there,
        I'm interested in purchasing Multi-Platform Advertising for my listing.
        If you could please provide more information and next steps, I would greatly appreciate it.`
    })
    window.open(`${APP_PATH}/chat/support-room`, '_blank')
    closeModal()
  }

  return (
    <Box>
      <Box marginBottom="xxxsmall">
        <Stack space="small">
          <Text size="xlarge" weight="medium">
            {t(
              'l.usage.credits.track_your_listings_in_all_platforms.title',
              'Track your listings in all platforms'
            )}
          </Text>
          <Text size="medium" weight="regular">
            {t(
              'l.usage.credits.analytics_report_content_2.text',
              `Receive monthly analytics on clicks, views, and inquiries for up to 100 syndicated listings with our report, available for an extra $30 per month. Please note that listings must be syndicated to receive a monthly report.`
            )}
          </Text>
        </Stack>
      </Box>
      <Bleed horizontal="large" bottom="large">
        <Box background="body" paddingX="large" paddingY="large">
          <Actions align="right">
            <ButtonLink
              type="submit"
              variant="transparent"
              href={`${IMAGES_URL}/extras/liv.rent_Analytics_Report_Example.pdf`}
              target="_blank"
              size="small"
              id={'id'}
            >
              {t('b.usage.dialog.view_full_example.title', 'View full example')}
            </ButtonLink>
            <Button
              type="submit"
              variant="solid"
              onClick={handleSendMessage}
              size="small"
              id={'id'}
            >
              {t('b.usage.dialog.contact_sales.title', 'Contact Sales')}
            </Button>
          </Actions>
        </Box>
      </Bleed>
    </Box>
  )
}

export default ModalContent
